import { GlobalState } from '../../components/actions';

const userLinkSelector = (state: GlobalState) => state.userLinks;

export const userLinkEntitySelector = (userId: string) => (state: GlobalState) =>
    userLinkSelector(state).userInfos[userId];
export const userLinkUserImageSelector = (userId: string) => (state: GlobalState) =>
    userLinkSelector(state).userImages[userId];
